{
  "mainLJ": {
    "title": "Pilot Logbook (Glider)",
    "nazaj": "Back"
  },
  "navsLJ": {
    "vnos": "Entry",
    "dnevnik": "Logbook"
  },
  "labelsLJ": {
    "datum": "Date:",
    "casO": "Departure time:",
    "krajV": "Takeoff location: LJAJ",
    "naloga": "Task",
    "stLetov": "Number of flights",
    "casP": "Arrival time:",
    "krajP": "Landing location: LJAJ",
    "model": "Type",
    "reg": "Aircraft registration: S5-XYZ",
    "nacinStarta": "Launch method",
    "ime": "Pilot in command name",
    "posadka": "Single / Multi crew:",
    "posadkaVec": "MULTI",
    "skupniCas": "Total flight time:",
    "stPristankovDN": "Number of landings (Day / Night):",
    "dan": "Day",
    "noc": "Night",
    "stPristankov": "Number of landings:",
    "op": "Operating conditions:",
    "opD": "Day",
    "opN": "Instrument",
    "vlogaP": "Pilot role:",
    "fstd": "Total FSTD time:",
    "kilometri": "Distance flown",
    "opomba": "Note"
  },
  "buttonsLJ": {
    "vnesiZapis": "Add entry"
  },
  "optionsLJ": {
    "aerozaprega": "Aerotow",
    "vitla": "Winch launch"
  },
  "obvestilaLJ": {
    "zapisDodan": "Entry successfully added.",
    "napakaVnosa": "Error while entering data.",
    "napakaInputa": "All fields must be completed to add an entry. Please check that all data is filled in!",
    "napakaBranja": "Error while reading data."
  }
}